export default {
  placeholder: 'Hae ravintolaa...',
};
